import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import StepTab from 'components/new_ui/Tabs/StepTab';
import routes from 'app/routes';

export default function Index() {
  const { pathname, state } = useLocation();

  const [currentTabItem, setCurrentTabItem] = useState(1);

  const isFree = state?.plan?.attributes?.is_free;

  useEffect(() => {
    const path = pathname.replace(/\d+/, ':planId');

    switch (path) {
      case routes.managers.plans.edit.plan_details():
        setCurrentTabItem(1);
        break;
      case routes.managers.plans.edit.services():
        setCurrentTabItem(2);
        break;
      case routes.managers.plans.edit.summary():
        setCurrentTabItem(3);
        break;
      case routes.managers.plans.edit.success():
        setCurrentTabItem(0);
        break;
      default:
        setCurrentTabItem(1);
    }
  }, [pathname]);

  return (
    <>
      {currentTabItem > 0 && <StepTab total={isFree ? 2 : 3} current={currentTabItem} />}

      <div className="content">
        <Outlet />
      </div>
    </>
  );
}
